"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.ends-with");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.number.constructor");

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

var _validate = require("@/utils/validate");

var _send = require("@/api/cms/send");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'DeliveryWuliu',
  components: {
    CommonUpload: _commonUpload.default
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    sendStatus: {
      type: Number,
      default: null
    },
    deliveryLog: {
      type: Object,
      default: null
    },
    customerInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    submitting: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    initiator: {
      type: String,
      default: ''
    },
    initiateTime: {
      type: String,
      default: ''
    },
    sendTaskId: {
      type: [String, Number],
      default: null
    },
    contractList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      auditing: false
    };
  },
  computed: {
    previewAttachmentList: function previewAttachmentList() {
      var _this = this;

      var data = this.form.logisticsAttachment;
      if (!data) return [];

      try {
        var raw = typeof data === 'string' ? JSON.parse(data) : data;
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        return raw.map(function (item) {
          var parsed = typeof item === 'string' ? JSON.parse(item) : item;
          var name = parsed.alias || parsed.localName || parsed.realName || '';

          var isImage = _this.isImageFile(name);

          var prefix = isImage ? imgPreviewPrefix : filePreviewPrefix;
          return {
            url: parsed.url || prefix + parsed.realName,
            name: name,
            isImage: isImage
          };
        });
      } catch (_unused) {
        return [];
      }
    },
    logisticsOrderPhotoList: function logisticsOrderPhotoList() {
      return this.parsePhotoList(this.deliveryLog && this.deliveryLog.logisticsOrderPhoto);
    },
    logisticsCollectionPhotoList: function logisticsCollectionPhotoList() {
      return this.parsePhotoList(this.deliveryLog && this.deliveryLog.logisticsCollectionPhoto);
    },
    deliveryChecklistPhotoList: function deliveryChecklistPhotoList() {
      return this.parsePhotoList(this.deliveryLog && this.deliveryLog.deliveryChecklistPhoto);
    },
    deliveryLoadingCompletePhotoList: function deliveryLoadingCompletePhotoList() {
      return this.parsePhotoList(this.deliveryLog && this.deliveryLog.deliveryLoadingCompletePhoto);
    }
  },
  methods: {
    // ==================== 审核方法 ====================
    handleReject: function handleReject() {
      var _this2 = this;

      if (!this.form.csAuditOpinion || !this.form.csAuditOpinion.trim()) {
        this.$message.warning('请填写您的审批意见');
        return;
      }

      this.$confirm('确定驳回该发货单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.doAudit(1011);
      }).catch(function () {});
    },
    handleApprove: function handleApprove() {
      var _this3 = this;

      this.$confirm('确定同意该发货单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.doAudit(1010);
      }).catch(function () {});
    },
    doAudit: function doAudit(status) {
      var _this4 = this;

      this.auditing = true;
      var contractNumber = this.contractList && this.contractList.length > 0 ? this.contractList[0].contractNumber || this.contractList[0].contractNo || this.contractList[0].custContractNo || '' : '';
      (0, _send.addSendTaskLog)({
        sendTaskId: this.sendTaskId,
        sendNumber: this.form.deliveryNo || '',
        contractNumber: contractNumber,
        step: String(status),
        remark: this.form.csAuditOpinion || ''
      }).then(function () {
        _this4.$message.success(status === 1011 ? '已驳回' : '已同意');

        _this4.$emit('audit-done');
      }).catch(function (error) {
        console.error('审核操作失败:', error);

        _this4.$message.error('操作失败，请重试');
      }).finally(function () {
        _this4.auditing = false;
      });
    },
    // ==================== 附件处理 ====================
    isImageFile: function isImageFile(fileName) {
      if (!fileName) return false;
      var imgExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp'];
      var ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
      return imgExtensions.includes(ext);
    },
    downloadAttachment: function downloadAttachment(item) {
      if (item.url) {
        fetch(item.url, {
          mode: 'cors'
        }).then(function (res) {
          return res.blob();
        }).then(function (blob) {
          var blobUrl = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = blobUrl;
          a.download = item.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
        }).catch(function () {
          window.open(item.url, '_blank');
        });
      }
    },
    handleAttachmentUpload: function handleAttachmentUpload(filePaths) {
      this.form.logisticsAttachment = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleAttachmentDel: function handleAttachmentDel(filePaths) {
      this.form.logisticsAttachment = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    handleOrderUpload: function handleOrderUpload(filePaths) {
      this.form.logisticsOrderPhoto = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleOrderDel: function handleOrderDel(filePaths) {
      this.form.logisticsOrderPhoto = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    handleCollectionUpload: function handleCollectionUpload(filePaths) {
      this.form.logisticsCollectionPhoto = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleCollectionDel: function handleCollectionDel(filePaths) {
      this.form.logisticsCollectionPhoto = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    handleChecklistPhotoUpload: function handleChecklistPhotoUpload(filePaths) {
      this.form.deliveryChecklist = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleChecklistPhotoDel: function handleChecklistPhotoDel(filePaths) {
      this.form.deliveryChecklist = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    handleLoadingCompletePhotoUpload: function handleLoadingCompletePhotoUpload(filePaths) {
      this.form.loadingCompletePhoto = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleLoadingCompletePhotoDel: function handleLoadingCompletePhotoDel(filePaths) {
      this.form.loadingCompletePhoto = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    // ==================== $refs methods ====================
    fillFromEdit: function fillFromEdit(row) {
      var _this5 = this;

      if (!row) return;
      this.form.logisticsDate = row.sendDate ? typeof row.sendDate === 'string' ? row.sendDate.split(' ')[0] : row.sendDate : '';
      this.form.expectedDeliveryDate = row.expectedDeliveryDate || '';
      this.form.logisticsTime = row.sendTime || '';
      this.form.logisticsCompany = row.sendCompany || '';
      this.form.logisticsWarehouseLocation = row.storageLocation || '';
      this.form.logisticsDeliveryPerson = row.sender || '';
      this.form.logisticsRemark = row.remark || '';
      this.form.receivePerson = row.receivePerson || this.customerInfo.contactPerson || '';
      this.form.receivePhone = row.receivePhone || this.customerInfo.contactNumber || '';
      this.form.receiveAddress = row.receiveAddress || this.customerInfo.contactAddress || '';
      this.form.logisticsAttachment = row.logisticsAttachment || row.attachment || '';
      this.form.logisticsTrackingNo = row.logisticsTrackingNo || '';
      this.form.logisticsProgress = row.logisticsProgress || '';
      this.form.logisticsOrderPhoto = row.logisticsOrderPhoto || '';
      this.form.logisticsCollectionPhoto = row.logisticsCollectionPhoto || '';
      this.form.deliveryChecklist = row.deliveryChecklist || '';
      this.form.loadingCompletePhoto = row.loadingCompletePhoto || ''; // 恢复附件

      if (row.logisticsAttachment) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('logisticsAttachment', row.logisticsAttachment);
        });
      } else if (row.attachment) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('logisticsAttachment', row.attachment);
        });
      }

      if (row.logisticsOrderPhoto) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('logisticsOrderUpload', row.logisticsOrderPhoto);
        });
      }

      if (row.logisticsCollectionPhoto) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('logisticsCollectionUpload', row.logisticsCollectionPhoto);
        });
      }

      if (row.deliveryChecklist) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('checklistPhotoUpload', row.deliveryChecklist);
        });
      }

      if (row.loadingCompletePhoto) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('loadingCompletePhotoUpload', row.loadingCompletePhoto);
        });
      }
    },
    fillFromCache: function fillFromCache(saveData) {
      var _this6 = this;

      if (!saveData) return;
      if (saveData.logisticsDate) this.form.logisticsDate = saveData.logisticsDate;
      if (saveData.logisticsTime) this.form.logisticsTime = saveData.logisticsTime;
      if (saveData.logisticsCompany || saveData.sendCompany) this.form.logisticsCompany = saveData.logisticsCompany || saveData.sendCompany;
      if (saveData.logisticsWarehouseLocation || saveData.storageLocation) this.form.logisticsWarehouseLocation = saveData.logisticsWarehouseLocation || saveData.storageLocation;
      if (saveData.logisticsDeliveryPerson || saveData.sender) this.form.logisticsDeliveryPerson = saveData.logisticsDeliveryPerson || saveData.sender;
      if (saveData.logisticsRemark) this.form.logisticsRemark = saveData.logisticsRemark;

      if (saveData.logisticsAttachment) {
        this.form.logisticsAttachment = saveData.logisticsAttachment;
        this.$nextTick(function () {
          return _this6._restoreAttachment('logisticsAttachment', saveData.logisticsAttachment);
        });
      } else if (saveData.attachment) {
        this.form.logisticsAttachment = typeof saveData.attachment === 'string' ? saveData.attachment : JSON.stringify(saveData.attachment);
        this.$nextTick(function () {
          return _this6._restoreAttachment('logisticsAttachment', _this6.form.logisticsAttachment);
        });
      }

      if (saveData.logisticsTrackingNo) this.form.logisticsTrackingNo = saveData.logisticsTrackingNo;
      if (saveData.logisticsProgress) this.form.logisticsProgress = saveData.logisticsProgress;
      if (saveData.logisticsOrderPhoto) this.form.logisticsOrderPhoto = saveData.logisticsOrderPhoto;
      if (saveData.logisticsCollectionPhoto) this.form.logisticsCollectionPhoto = saveData.logisticsCollectionPhoto;
      if (saveData.deliveryChecklist) this.form.deliveryChecklist = saveData.deliveryChecklist;
      if (saveData.loadingCompletePhoto) this.form.loadingCompletePhoto = saveData.loadingCompletePhoto;
    },
    buildSaveData: function buildSaveData() {
      return {
        logisticsDate: this.form.logisticsDate,
        logisticsTime: this.form.logisticsTime,
        logisticsCompany: this.form.logisticsCompany,
        logisticsWarehouseLocation: this.form.logisticsWarehouseLocation,
        logisticsDeliveryPerson: this.form.logisticsDeliveryPerson,
        logisticsRemark: this.form.logisticsRemark,
        logisticsAttachment: this.form.logisticsAttachment,
        logisticsTrackingNo: this.form.logisticsTrackingNo,
        logisticsProgress: this.form.logisticsProgress,
        logisticsOrderPhoto: this.form.logisticsOrderPhoto,
        logisticsCollectionPhoto: this.form.logisticsCollectionPhoto,
        deliveryChecklist: this.form.deliveryChecklist,
        loadingCompletePhoto: this.form.loadingCompletePhoto
      };
    },
    getSubmitDataPatch: function getSubmitDataPatch(submitData) {
      submitData.sendDate = this.form.logisticsDate || '';
      submitData.sendTime = this.form.logisticsTime || '';
      submitData.sendCompany = this.form.logisticsCompany || '';
      submitData.storageLocation = this.form.logisticsWarehouseLocation || '';
      submitData.sender = this.form.logisticsDeliveryPerson || '';
      submitData.remark = this.form.logisticsRemark || '';
      submitData.receivePerson = this.form.receivePerson || '';
      submitData.receivePhone = this.form.receivePhone || '';
      submitData.receiveAddress = this.form.receiveAddress || '';
      submitData.logisticsTrackingNo = this.form.logisticsTrackingNo || '';
      submitData.logisticsProgress = this.form.logisticsProgress || '';
      submitData.logisticsOrderPhoto = this.form.logisticsOrderPhoto || '';
      submitData.logisticsCollectionPhoto = this.form.logisticsCollectionPhoto || '';
      submitData.deliveryChecklist = this.form.deliveryChecklist || '';
      submitData.loadingCompletePhoto = this.form.loadingCompletePhoto || '';

      if (this.form.logisticsAttachment) {
        submitData.attachment = this.form.logisticsAttachment;
      }

      return submitData;
    },
    fillFromSendInfo: function fillFromSendInfo(row) {
      this.fillFromEdit(row);
    },
    buildDeliverySubmitPhoto: function buildDeliverySubmitPhoto() {
      var parseVal = function parseVal(v) {
        if (!v) return v;

        try {
          return JSON.parse(v);
        } catch (_unused2) {
          return v;
        }
      };

      return {
        logisticsOrderPhoto: parseVal(this.form.logisticsOrderPhoto),
        logisticsCollectionPhoto: parseVal(this.form.logisticsCollectionPhoto),
        logisticsTrackingNo: this.form.logisticsTrackingNo,
        logisticsProgress: this.form.logisticsProgress
      };
    },
    getRules: function getRules() {
      return {
        logisticsCompany: [{
          required: true,
          message: '请选择物流公司',
          trigger: 'blur'
        }],
        logisticsDate: [{
          required: true,
          message: '请选择计划发货日期',
          trigger: 'change'
        }],
        receivePerson: [{
          required: true,
          message: '请输入收货人',
          trigger: 'blur'
        }],
        receivePhone: [{
          required: true,
          message: '请输入收货人电话',
          trigger: 'blur'
        }, {
          validator: _validate.validatePhone,
          trigger: 'blur'
        }],
        receiveAddress: [{
          required: true,
          message: '收货信息必填',
          trigger: 'change'
        }],
        logisticsWarehouseLocation: [{
          required: true,
          message: '请输入仓库位置',
          trigger: 'blur'
        }],
        logisticsDeliveryPerson: [{
          required: true,
          message: '请输入发货人',
          trigger: 'blur'
        }]
      };
    },
    fillDeliveryInfo: function fillDeliveryInfo(deliveryLog) {
      return {
        logisticsOrderPhoto: deliveryLog.logisticsOrderPhoto || [],
        logisticsCollectionPhoto: deliveryLog.logisticsCollectionPhoto || [],
        logisticsTrackingNo: deliveryLog.logisticsTrackingNo || '',
        logisticsProgress: deliveryLog.logisticsProgress || '',
        deliveryChecklistPhoto: deliveryLog.deliveryChecklistPhoto || [],
        deliveryLoadingCompletePhoto: deliveryLog.deliveryLoadingCompletePhoto || []
      };
    },
    // ==================== 辅助方法 ====================
    parsePhotoList: function parsePhotoList(data) {
      if (!data) return [];

      try {
        var arr = Array.isArray(data) ? data : typeof data === 'string' ? JSON.parse(data) : [];
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        return arr.map(function (item) {
          var parsed = typeof item === 'string' ? JSON.parse(item) : item;
          return {
            url: parsed.url || imgPreviewPrefix + parsed.realName,
            name: parsed.alias || parsed.localName || parsed.realName || ''
          };
        });
      } catch (_unused3) {
        return [];
      }
    },
    _restoreAttachment: function _restoreAttachment(refName, data) {
      var ref = this.$refs[refName];
      if (!ref) return;

      try {
        var raw = typeof data === 'string' ? JSON.parse(data) : data;
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        var files = raw.map(function (item) {
          var parsed = typeof item === 'string' ? JSON.parse(item) : item;
          var name = (parsed.alias || parsed.localName || parsed.realName || '').toLowerCase();
          var isImage = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp'].some(function (e) {
            return name.endsWith(e);
          });
          var prefix = isImage ? imgPreviewPrefix : filePreviewPrefix;
          return {
            realName: parsed.realName,
            url: parsed.url || prefix + parsed.realName,
            type: parsed.type,
            alias: parsed.localName || parsed.alias
          };
        });
        ref.setFileList(files);
      } catch (e) {}
    }
  }
};
exports.default = _default2;